import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { HttpAccountFilters } from '@account-users/account/models/IAccount';
import { ISectionMap } from '../models/Audience';

@Injectable({
  providedIn: 'root',
})
export class AccountSectionsService {
  constructor(
    private http: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  fetchSections(accountId: string, filters?: HttpAccountFilters) {
    return this.http.get<ISectionMap>(
      `${this.apiBaseUrl}accounts/${accountId}/sections`,
      { params: filters },
    );
  }
}
